var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"fullDocs"},_vm._l((_vm.listData),function(doc,index){return _c('full-doc',{key:index,attrs:{"doc-data":doc,"is-read":_vm.isRead,"no-project-name":_vm.noProjectName,"no-material-name":_vm.noMaterialName}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }